<template>
<div :title="t('headerTools.profile')" class="common-header-profile" v-clickoutside="hidePanel">
  <div
    :class="[
      'profile-button',
      { active: visiable }
    ]"
    @click="visiable = !visiable"
  >
    <div
      :class="['avatar', { badge: update }]"
      :style="{
        backgroundImage: 'url(' + userInfo.avatar + ')'
      }"
    >
    </div>
  </div>
  <div class="profile-panel" v-show="visiable">
    <header>
      <div class="user-info">
        <div
          class="avatar"
          :style="{
            backgroundImage: 'url(' + userInfo.avatar + ')'
          }"
        >
        </div>
        <div class="info">
          <div class="name">
            <span class="real-name" :title="userInfo.nickname">{{ userInfo.nickname }}</span><span
             class="nick-name" :title="userInfo.real_name">{{ userInfo.real_name }}</span>
          </div>
          <div class="email" :title="userInfo.email">{{ userInfo.email }}</div>
        </div>
      </div>
      <div class="custom-area">
        <slot name="panel-header"></slot>
      </div>
    </header>
    <main>
      <div class="functions">
        <ul>
          <li
            v-for="item of syntheticModules"
            :key="item.id"
            :track-by="item.id"
          >
            <div
              :class="['module', {
                active: activeModule.id === item.id,
                disabled: item.disabled
              }]"
              v-if="item.type === 'module'"
              @click="clickHandler(item)"
              @mouseenter="active = item.id"
            >
              <span class="title" :title="item.title">
                <span class="text">{{ item.title }}</span>
                <span class="badge" v-if="item.badge"></span>

                <div class="tooltip" v-if="item.disabled">{{ tip(item) }}</div>
              </span>
            </div>
            <div class="separator" v-if="item.type === 'separator'"></div>
          </li>
        </ul>
      </div>
      <div class="explain" :title="activeModule.title">
        <div class="image">
          <img :src="activeModule.icon" alt="">
        </div>
        <div class="title">
          {{ activeModule.title }}
        </div>
        <div class="describe" v-html="activeModule.describe"></div>
      </div>
    </main>
  </div>
</div>
</template>

<script>
import Icon from '../../components/icon'
import clickoutside from '../../directives/clickoutside'
import i18nHandle from '../../locales'
import ImageProfileE from '../../assets/images/profile-e.png'
import ImageProfileLog from '../../assets/images/profile-log.png'
import ImageProfileLogout from '../../assets/images/profile-logout.png'
import ImageProfileMe from '../../assets/images/profile-me.png'
import ImageProfileRecommend from '../../assets/images/profile-recommend.png'
import ImageProfileSetting from '../../assets/images/profile-setting.png'
import ImageProfileUpdate from '../../assets/images/profile-update.png'

const I18N_MAP = {
  user: {
    title: i18nHandle.t('profile.user'),
    describe: i18nHandle.t('profile.userDesc'),
  },
  enterprise: {
    title: i18nHandle.t('profile.enterprize'),
    describe: i18nHandle.t('profile.enterprizeDesc'),
  },
  recommend: {
    title: i18nHandle.t('profile.recommend'),
    describe: i18nHandle.t('profile.recommendDesc'),
  },
  log: {
    title: i18nHandle.t('profile.log'),
    describe: i18nHandle.t('profile.logDesc'),
  },
  update: {
    title: i18nHandle.t('profile.update'),
    describe: i18nHandle.t('profile.updateDesc'),
  },
  setting: {
    title: i18nHandle.t('profile.setting'),
    describe: i18nHandle.t('profile.settingDesc'),
  },
  logout: {
    title: i18nHandle.t('profile.logout'),
  },
  noRecommend: i18nHandle.t('profile.noRecommend'),
  nonactivated: i18nHandle.t('profile.nonactivated'),
  noPermission: i18nHandle.t('profile.noPermission'),
}

export default {
  components: {
    Icon,
  },
  directives: {
    clickoutside,
  },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
    operations: {
      type: Object,
      default() {
        return {}
      },
    },
    userInfo: {
      type: Object,
      required: true,
      default() {
        return {
          avatar: '',
          real_name: '',
          nickname: '',
          email: '',
        }
      },
    },
    customTip: {
      type: Function,
    },
  },
  data() {
    return {
      visiable: false,
      modules: [
        {
          id: 'me',
          title: I18N_MAP.user.title,
          describe: I18N_MAP.user.describe,
          icon: ImageProfileMe,
          type: 'module',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'e',
          title: I18N_MAP.enterprise.title,
          describe: I18N_MAP.enterprise.describe,
          icon: ImageProfileE,
          type: 'module',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'recommend',
          title: I18N_MAP.recommend.title,
          describe: I18N_MAP.recommend.describe,
          icon: ImageProfileRecommend,
          type: 'module',
          visiable: false,
          disabled: true,
          privilege: true,
        },
        {
          id: 'log',
          title: I18N_MAP.log.title,
          describe: I18N_MAP.log.describe,
          icon: ImageProfileLog,
          type: 'module',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'separator1',
          type: 'separator',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'update',
          title: I18N_MAP.update.title,
          describe: I18N_MAP.update.describe,
          icon: ImageProfileUpdate,
          type: 'module',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'setting',
          title: I18N_MAP.setting.title,
          describe: I18N_MAP.setting.describe,
          icon: ImageProfileSetting,
          type: 'module',
          visiable: false,
          disabled: false,
          privilege: true,
        },
        {
          id: 'separator2',
          type: 'separator',
          visiable: true,
          disabled: false,
          privilege: true,
        },
        {
          id: 'logout',
          title: I18N_MAP.logout.title,
          describe: '',
          icon: ImageProfileLogout,
          type: 'module',
          visiable: true,
          disabled: false,
          privilege: true,
        },
      ],
      active: 'me',
    }
  },
  computed: {
    syntheticModules() {
      const modules = this.modules
        .map(item =>
          Object.assign(
            {
              handler(module) {
                // eslint-disable-next-line
                console.warn('请输入处理函数', module)
              },
              badge: item.id === 'update' && this.update,
            },
            item,
            this.operations[item.id]
          )
        )
        .filter(item => item.visiable)

      const head = modules.slice(0, 1)

      return modules.slice(1).reduce((result, current) => {
        if (
          current.type === 'separator' &&
          result[result.length - 1].type === 'separator'
        ) {
          return result
        }
        return result.concat(current)
      }, head)
    },
    activeModule() {
      return this.syntheticModules.find(item => item.id === this.active)
    },
  },
  methods: {
    hidePanel() {
      this.visiable = false
    },
    clickHandler(module) {
      if (module.disabled) {
        return
      }

      const currentModule = this.syntheticModules.find(
        item => item.id === module.id
      )

      this.hidePanel()
      currentModule.handler(module)
    },
    tip(item) {
      if (typeof this.customTip === 'function') {
        return this.customTip(item)
      }
      switch (item.id) {
        case 'recommend':
          return I18N_MAP.noRecommend
        default:
          return item.privilege ? I18N_MAP.nonactivated : I18N_MAP.noPermission
      }
    },
    t: i18nHandle.t,
  },
}
</script>

<style lang="scss">
@import '../../assets/styles/_variable';

.common-header-profile {
  position: relative;

  .profile-button {
    display: flex;
    align-items: center;
    cursor: pointer;

    &.active,
    &:hover {
      color: #2997f5;
      .arrow {
        color: #2997f5;
      }
    }

    &.active {
      .arrow {
        transform: rotate(180deg);
      }
    }

    .avatar {
      $size: 30px;

      position: relative;
      box-sizing: border-box;
      width: $size;
      height: $size;
      margin-right: 8px;
      border: 1px solid #e6e6e6;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      &.badge::after {
        position: absolute;
        top: 0;
        right: -3px;
        box-sizing: border-box;
        width: 8px;
        height: 8px;
        border: 1px solid #fff;
        border-radius: 50%;
        background-color: #e95b5b;
        content: '';
      }
    }
    .arrow {
      color: #909090;
      transition: transform 0.3s;
    }
  }

  .profile-panel {
    position: absolute;
    top: calc(#{$layoutHeaderHeight} + -20px);
    right: -10px;
    width: 318px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);

    &::before {
      position: absolute;
      top: -6px;
      right: 26px;
      width: 12px;
      height: 12px;
      background-color: #fff;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);
      content: '';
      transform: rotate(45deg);
    }

    &::after {
      position: absolute;
      top: 0;
      right: 20px;
      width: 25px;
      height: 12px;
      background-color: #fff;
      content: '';
    }

    header {
      margin: 0 24px;
      padding: 22px 0;
      border-bottom: 1px solid#d6d8dd;
      .user-info {
        display: flex;
      }
      .avatar {
        box-sizing: border-box;
        width: 52px;
        height: 52px;
        margin-right: 20px;
        border: 1px solid #d7d7d7;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .info {
        .name {
          color: $mainColor;
          font-size: 18px;
          line-height: 25px;
          .real-name {
            display: inline-block;
            overflow: hidden;
            max-width: 112px;
            white-space: nowrap;
            text-overflow: ellipsis;
            letter-spacing: 0;
            font-weight: bold;
          }
          .nick-name {
            display: inline-block;
            overflow: hidden;
            max-width: 60px;
            margin-left: 12px;
            color: $mainColor;
            font-size: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            letter-spacing: 0;
          }
        }
        .email {
          overflow: hidden;
          max-width: 194px;
          color: #535d71;
          font-size: 14px;
          line-height: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          letter-spacing: 0;
        }
      }
    }

    main {
      display: flex;
      flex-direction: row;
      & > .functions {
        box-sizing: border-box;
        width: 126px;
        margin: 16px 0 16px 15px;
        ul {
          margin: 0;
          padding: 0;
          border-right: 1px solid #d6d8dd;
        }
        li {
          list-style: none;
          .separator {
            width: 86px;
            height: 1px;
            margin: 16px 0;
            margin-left: 10px;
            background: #d6d8dd;
            line-height: 0;
          }
          .module {
            display: inline-block;
            display: flex;
            height: 30px;
            margin: 5px 0;
            color: $mainColor;
            font-size: 14px;
            line-height: 30px;

            align-items: center;
            &:not(.disabled):hover {
              .title {
                color: #0884f3;
                background-color: rgba(8, 132, 243, 0.07);
                font-weight: bold;
              }
            }

            &.disabled {
              .title {
                cursor: not-allowed;
                color: #9e9e9e;
              }
            }

            .title {
              display: flex;
              position: relative;
              padding: 0 10px;
              border-radius: 4px;
              color: $mainColor;
              cursor: pointer;
              user-select: none;

              align-items: center;

              .badge {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #e95b5b;
                position: absolute;
                top: 4px;
                right: 4px;
              }

              &:hover .tooltip {
                visibility: visible;
              }
            }

            .tooltip {
              visibility: hidden;
              position: absolute;
              top: 50%;
              left: calc(100% + 5px);
              height: 25px;
              padding: 0 10px;
              border-radius: 2px;
              color: #fff;
              background-color: rgba(39, 45, 56, 0.9);
              font-size: 12px;
              line-height: 25px;
              text-align: center;
              white-space: nowrap;
              transform: translateY(-50%);

              &::before {
                position: absolute;
                top: 50%;
                left: -3px;
                width: 0;
                height: 0;
                border-width: 3px 3px 3px 0;
                border-style: solid;
                border-color: transparent rgba(38, 53, 81, 0.9) transparent
                  transparent;
                content: '';
                transform: translateY(-50%);
              }
            }
          }
        }
      }
      & > .explain {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px 24px;
        color: #fff;
        text-align: center;

        align-items: center;
        justify-content: center;
        flex: 1;

        .image {
          display: flex;
          width: 124px;
          height: 124px;
          margin-bottom: 14px;

          align-items: center;
          justify-content: center;
        }

        .title {
          min-height: 18px;
          margin-bottom: 14px;
          color: $mainColor;
          font-size: 18px;
          font-size: 18px;
          line-height: 1;
        }

        .describe {
          min-height: 54px;
          color: #748099;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}

.lang-en {
  .common-header-profile .profile-panel main > .explain .describe {
    text-align: left;
  }
}
</style>